import axios from "axios";
import authHeader from '@/services/Auth-header.js';
import { defaultbaseUrl } from './config'

const http = axios.create({
  baseURL: defaultbaseUrl,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
});

http.interceptors.request.use(config => {
  const authorization = authHeader();
  if (authorization) config.headers.Authorization = authorization;
  else delete config.headers.Authorization;
  return config;
});

export default http;
